"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OPERATORS = exports.ACORN_AST_TYPES = void 0;
exports.ACORN_AST_TYPES = {
    EXPRESSION_STATEMENT: 'ExpressionStatement',
    CALL_EXPRESSION: 'CallExpression',
    IDENTIFIER: 'Identifier',
};
exports.OPERATORS = ['=', '<>', '<', '<=', '>', '>='];
//# sourceMappingURL=types.js.map